module.exports = __webpack_public_path__ + "static/img/rwm.9abb4533.png";